<template>
     <drop-down class="nav-item"
                     :title="currentLang"
                     title-classes="nav-link"
                     >
            <a class="dropdown-item" href="#" v-for="(locale, index) in langs" :key="index" @click.prevent="setCurrentLang(locale)">{{locale}}</a>
    </drop-down>
</template>

<script>
import baseApi from "@/baseApi";
import store from "@/store";

export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    langs(){
      return this.$store.getters.GET_LANGS;
    }
  },
  data() {
    return {
      currentLang: localStorage.getItem('locale')
    };
  },
  created(){
    this.initLang()
  },
  methods: {
    initLang(){
      let vm = this;
      setTimeout(() => {
        for (let index = 0; index < vm.langs.length; index++) {
          vm.currentLang = vm.langs[index] == localStorage.getItem('locale') ? vm.langs[index] : vm.currentLang;
        }
      }, 500);
    },
    getCurrentLang(){
      return this.langs[localStorage.getItem('locale')];
    },
    setCurrentLang(locale){
      localStorage.setItem('locale', locale);
      this.currentLang = locale;
      const res = baseApi().get('/info?langauge='+locale).then((response)=>{
        if(response.data.code === 200){
          this.$store.dispatch('SET_TRANS', response.data.data.trans);
           this.$store.dispatch('SET_LANGS', response.data.data.langs);
          localStorage.setItem("trans", JSON.stringify(response.data.data.trans));
          localStorage.setItem("langs", JSON.stringify(response.data.data.langs));
          localStorage.setItem("locale", response.data.data.locale);
          this.trans = response.data.data.trans;
          this.langs = response.data.data.langs;
        }else{
        }
      });
    }
  }
};
</script>
